/* Mirage collection controls: connects the compact rail to Shopify's native filters. */
(() => {
  const approvedSorts = new Set([
    'best-selling',
    'price-descending',
    'price-ascending',
    'created-descending',
    'manual'
  ]);

  const currentUrl = new URL(window.location.href);
  const currentSort = currentUrl.searchParams.get('sort_by');
  if (currentSort && !approvedSorts.has(currentSort)) {
    currentUrl.searchParams.delete('sort_by');
    window.location.replace(currentUrl.toString());
    return;
  }

  const panelKey = (label) => (label || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

  const showPanel = (label) => {
    const drawer = document.querySelector('#filterCollectionProductDrawer');
    if (!drawer) return;

    const activePanel = panelKey(label);
    drawer.querySelectorAll('[data-mirage-filter-panel]').forEach((panel) => {
      panel.hidden = Boolean(activePanel) && panel.dataset.mirageFilterPanel !== activePanel;
    });
  };

  const focusPanel = (label) => {
    showPanel(label);
    if (!label) return;

    window.setTimeout(() => {
      /* Shopify's drawer opener resets the details state after the trigger
       * click. Re-apply the requested panel once that native update finishes. */
      showPanel(label);
      const summaries = [...document.querySelectorAll('#filterCollectionProductDrawer .js-summary-filter')];
      const normalizedLabel = label.toLowerCase();
      const summary = summaries.find((item) => item.textContent.trim().toLowerCase().startsWith(normalizedLabel));
      const details = summary && summary.closest('details');
      if (!summary || !details || details.open) return;
      summary.click();
      details.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }, 180);
  };

  const colorDialog = document.querySelector('#mirageColorFilterDialog');
  const closeColorDialog = () => {
    if (colorDialog?.open) colorDialog.close();
  };

  document.querySelectorAll('[data-mirage-color-modal-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', () => colorDialog?.showModal());
  });

  colorDialog?.addEventListener('click', (event) => {
    if (event.target === colorDialog) closeColorDialog();
  });

  const drawerColorItems = [...document.querySelectorAll('#filterCollectionProductDrawer [data-mirage-filter-panel="color"] .filter-form__item')];
  const drawerColorIsDark = (color) => {
    const rgb = color.match(/\d+/g)?.slice(0, 3).map(Number);
    if (!rgb || rgb.length < 3) return true;
    return (0.2126 * rgb[0]) + (0.7152 * rgb[1]) + (0.0722 * rgb[2]) < 145;
  };
  const paintDrawerColor = (item) => {
    const label = item.querySelector('.form__label');
    const swatch = item.querySelector('.product-swatches');
    const color = swatch ? window.getComputedStyle(swatch).backgroundColor : '';
    if (!label || !color || color === 'rgba(0, 0, 0, 0)') return;
    const foreground = drawerColorIsDark(color) ? '#fff' : '#101419';
    label.style.background = color;
    label.style.color = foreground;
    label.querySelectorAll('.product-swatches-label').forEach((element) => { element.style.color = foreground; });
  };
  const clearDrawerColor = (item) => {
    const label = item.querySelector('.form__label');
    if (!label) return;
    label.style.removeProperty('background');
    label.style.removeProperty('color');
    label.querySelectorAll('.product-swatches-label').forEach((element) => { element.style.removeProperty('color'); });
  };
  drawerColorItems.forEach((item) => {
    const input = item.querySelector('input');
    item.addEventListener('mouseenter', () => paintDrawerColor(item));
    item.addEventListener('mouseleave', () => {
      if (input?.checked) paintDrawerColor(item);
      else clearDrawerColor(item);
    });
    input?.addEventListener('change', () => {
      if (input.checked) paintDrawerColor(item);
      else clearDrawerColor(item);
    });
    if (input?.checked) paintDrawerColor(item);
  });

  const normalizeDrawerColorName = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  document.querySelectorAll('[data-mirage-active-color]').forEach((pill) => {
    const requestedColor = normalizeDrawerColorName(pill.dataset.mirageActiveColor);
    const matchingItem = drawerColorItems.find((item) => normalizeDrawerColorName(item.querySelector('.product-swatches-label')?.textContent) === requestedColor);
    const swatch = matchingItem?.querySelector('.product-swatches');
    const color = swatch ? window.getComputedStyle(swatch).backgroundColor : '';
    if (!color || color === 'rgba(0, 0, 0, 0)') return;
    const foreground = drawerColorIsDark(color) ? '#fff' : '#101419';
    pill.style.background = color;
    pill.style.borderColor = color;
    pill.style.color = foreground;
    pill.querySelectorAll('svg, path').forEach((element) => { element.style.color = foreground; element.style.fill = 'currentColor'; });
  });

  /* The theme's AJAX reset element can swallow clicks after the product grid has
   * been customized. Let Shopify build the removal URL, then follow that URL
   * directly so each color chip reliably removes only its own filter. */
  document.addEventListener('click', (event) => {
    const removeLink = event.target.closest('a[data-mirage-active-color], a.mirage-clear-all');
    if (!removeLink || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const href = removeLink.getAttribute('href');
    if (!href) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(new URL(href, window.location.origin).toString());
  }, true);

  document.querySelectorAll('[data-mirage-color-modal-close]').forEach((button) => {
    button.addEventListener('click', closeColorDialog);
  });

  document.querySelectorAll('[data-mirage-color-clear]').forEach((button) => {
    button.addEventListener('click', () => {
      colorDialog?.querySelectorAll('[data-mirage-color-option]').forEach((input) => { input.checked = false; });
    });
  });

  document.querySelectorAll('[data-mirage-color-form]').forEach((form) => {
    const applyButton = form.querySelector('.mirage-color-modal__apply');
    const colorOptions = [...form.querySelectorAll('.mirage-color-modal__option')];
    const getSwatchColor = (option) => {
      const swatch = option.querySelector('.product-swatches');
      const style = swatch ? window.getComputedStyle(swatch) : null;
      return style?.backgroundColor && style.backgroundColor !== 'rgba(0, 0, 0, 0)'
        ? style.backgroundColor
        : '#1d2c46';
    };
    const colorIsDark = (color) => {
      const rgb = color.match(/\d+/g)?.slice(0, 3).map(Number);
      if (!rgb || rgb.length < 3) return true;
      const luminance = (0.2126 * rgb[0]) + (0.7152 * rgb[1]) + (0.0722 * rgb[2]);
      return luminance < 145;
    };
    const updateApplyButton = () => {
      if (!applyButton) return;
      const colors = colorOptions
        .filter((option) => option.querySelector('input')?.checked)
        .map(getSwatchColor);

      if (!colors.length) {
        applyButton.style.removeProperty('background');
        applyButton.style.removeProperty('color');
        return;
      }

      const step = 100 / colors.length;
      const stops = colors.flatMap((color, index) => [
        `${color} ${index * step}%`,
        `${color} ${(index + 1) * step}%`
      ]).join(', ');
      applyButton.style.background = `linear-gradient(90deg, ${stops})`;
      applyButton.style.color = '#fff';
    };

    const paintColorOption = (option) => {
      const color = getSwatchColor(option);
      const foreground = colorIsDark(color) ? '#fff' : '#101419';
      option.style.background = color;
      option.style.borderColor = color;
      option.style.color = foreground;
      option.querySelectorAll('.mirage-color-modal__label, .mirage-color-modal__count').forEach((element) => {
        element.style.color = foreground;
      });
    };

    const clearColorOption = (option) => {
      option.style.removeProperty('background');
      option.style.removeProperty('border-color');
      option.style.removeProperty('color');
      option.querySelectorAll('.mirage-color-modal__label, .mirage-color-modal__count').forEach((element) => {
        element.style.removeProperty('color');
      });
    };

    colorOptions.forEach((option) => {
      const input = option.querySelector('input');
      option.addEventListener('mouseenter', () => {
        paintColorOption(option);
      });
      option.addEventListener('mouseleave', () => {
        if (input?.checked) paintColorOption(option);
        else clearColorOption(option);
      });
      input?.addEventListener('change', () => {
        if (input.checked) paintColorOption(option);
        else clearColorOption(option);
        updateApplyButton();
      });
    });
    window.setTimeout(() => {
      colorOptions.forEach((option) => {
        if (option.querySelector('input')?.checked) paintColorOption(option);
      });
      updateApplyButton();
    }, 80);

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const url = new URL(window.location.href);
      const colorInputs = [...form.querySelectorAll('[data-mirage-color-option]')];
      new Set(colorInputs.map((input) => input.name)).forEach((name) => url.searchParams.delete(name));
      colorInputs.filter((input) => input.checked).forEach((input) => url.searchParams.append(input.name, input.value));
      window.location.assign(url.toString());
    });
  });

  const updateCardColorName = (button) => {
    const card = button.closest('.card__content');
    const name = card?.querySelector('[data-mirage-card-color-name] strong');
    if (name && button.dataset.mirageCardColorValue) name.textContent = button.dataset.mirageCardColorValue;
  };

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-mirage-card-color-value]');
    if (swatch) updateCardColorName(swatch);
  });

  const normalizeColor = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  const activeColorPills = [...document.querySelectorAll('[data-mirage-active-color]')];
  const urlColorValues = [...new URLSearchParams(window.location.search).entries()]
    .filter(([key, value]) => key === 'filter.v.option.color' && !String(value).startsWith('gid://'))
    .map(([, value]) => value);
  const selectedColorValues = [...new Set((activeColorPills.length
    ? activeColorPills.map((pill) => pill.dataset.mirageActiveColor)
    : urlColorValues
  ).filter(Boolean))];
  const productGrid = document.querySelector('#collectionProductGrid');

  const copyVariantImage = (target, source) => {
    if (!target || !source) return;
    ['src', 'srcset', 'sizes', 'alt', 'width', 'height'].forEach((attribute) => {
      const value = source.getAttribute(attribute);
      if (value) target.setAttribute(attribute, value);
      else target.removeAttribute(attribute);
    });
  };

  const applyCardVariant = (card, swatch) => {
    if (!card || !swatch) return;
    const templateImage = swatch.querySelector('template')?.content?.querySelector('img');
    const variantUrl = swatch.dataset.mirageVariantUrl || templateImage?.dataset.url;
    const imageId = swatch.dataset.productImageId;
    const primaryImage = imageId ? card.querySelector(`#${CSS.escape(imageId)}`) : null;

    copyVariantImage(primaryImage, templateImage);
    card.querySelectorAll('.product__image-second img').forEach((image) => copyVariantImage(image, templateImage));

    if (variantUrl) {
      const linkClass = swatch.dataset.productLinkClass;
      if (linkClass) {
        card.querySelectorAll(`.${CSS.escape(linkClass)}`).forEach((link) => {
          link.setAttribute('href', variantUrl);
        });
      }
    }

    card.querySelectorAll('[data-mirage-card-color-value]').forEach((button) => {
      const isSelected = button === swatch;
      button.classList.toggle('btn-active', isSelected);
      if (isSelected) button.setAttribute('aria-current', 'true');
      else button.removeAttribute('aria-current');
    });

    const selectedColor = swatch.dataset.mirageCardColorValue;
    const colorName = card.querySelector('[data-mirage-card-color-name] strong');
    if (colorName && selectedColor) colorName.textContent = selectedColor;
    if (selectedColor) card.dataset.mirageColorVariant = normalizeColor(selectedColor);
  };

  if (productGrid && selectedColorValues.length && !productGrid.dataset.mirageColorSplit) {
    productGrid.dataset.mirageColorSplit = 'true';

    productGrid.querySelectorAll(':scope > .collection-product-clm').forEach((originalCard) => {
      const swatches = [...originalCard.querySelectorAll('[data-mirage-card-color-value]')];
      const matchingSwatches = selectedColorValues
        .map((selectedColor) => swatches.find((swatch) => normalizeColor(swatch.dataset.mirageCardColorValue) === normalizeColor(selectedColor)))
        .filter(Boolean);

      if (!matchingSwatches.length) return;

      const colorCards = matchingSwatches.map((sourceSwatch, index) => {
        const colorCard = originalCard.cloneNode(true);
        const selectedColor = sourceSwatch.dataset.mirageCardColorValue;
        const colorSwatch = [...colorCard.querySelectorAll('[data-mirage-card-color-value]')]
          .find((swatch) => normalizeColor(swatch.dataset.mirageCardColorValue) === normalizeColor(selectedColor));
        const uniqueSuffix = `-mirage-color-${index + 1}`;

        colorCard.querySelectorAll('[id]').forEach((element) => {
          const previousId = element.id;
          const nextId = `${previousId}${uniqueSuffix}`;
          element.id = nextId;
          colorCard.querySelectorAll(`[data-product-image-id="${previousId}"]`).forEach((swatch) => {
            swatch.dataset.productImageId = nextId;
          });
        });

        colorCard.querySelectorAll('[data-product-link-class]').forEach((swatch) => {
          const previousClass = swatch.dataset.productLinkClass;
          if (!previousClass) return;
          const nextClass = `${previousClass}${uniqueSuffix}`;
          colorCard.querySelectorAll('*').forEach((element) => {
            if (element.classList?.contains(previousClass)) {
              element.classList.remove(previousClass);
              element.classList.add(nextClass);
            }
          });
          swatch.dataset.productLinkClass = nextClass;
        });

        return { colorCard, colorSwatch };
      });

      originalCard.replaceWith(...colorCards.map(({ colorCard }) => colorCard));
      colorCards.forEach(({ colorCard, colorSwatch }) => applyCardVariant(colorCard, colorSwatch));
    });
  }

  document.addEventListener('click', (event) => {
    const sortOption = event.target.closest('[data-mirage-sort-option]');
    if (sortOption) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortOption.dataset.mirageSortOption);
      window.location.assign(url.toString());
      return;
    }

    const filterButton = event.target.closest('[data-mirage-filter-trigger], [data-mirage-filter-target]');
    if (filterButton) {
      focusPanel(filterButton.dataset.mirageFilterTarget);
      return;
    }
  }, true);

  document.addEventListener('change', (event) => {
    const sortSelect = event.target.closest('[data-mirage-sort-select]');
    if (!sortSelect) return;

    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortSelect.value);
    window.location.assign(url.toString());
  });
})();
